module.exports = __webpack_public_path__ + "img/01.d8e64826.png";